/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VerificationCodeDto } from '../../models/verification-code-dto';
import { VerificationResponseDto } from '../../models/verification-response-dto';

export interface VerificationCode$Params {
      body: VerificationCodeDto
}

export function verificationCode(http: HttpClient, rootUrl: string, params: VerificationCode$Params, context?: HttpContext): Observable<StrictHttpResponse<VerificationResponseDto>> {
  const rb = new RequestBuilder(rootUrl, verificationCode.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VerificationResponseDto>;
    })
  );
}

verificationCode.PATH = '/api/v1/code';
